module.exports = __webpack_public_path__ + "img/24_55.54387e01.png";